<template>
  <div>
    <ul class="sideicon">
      <li class="terms" @click="termsOpen = !termsOpen">
        <img src="@/assets/images/terms.svg" alt="Terms of Use" />
        <span>Terms of Use</span>
      </li>
      <li class="policy" @click="policyOpen = !policyOpen">
        <img src="@/assets/images/policy.svg" alt="Security Policy" />
        <span>Security Policy</span>
      </li>
    </ul>

    <transition name="overlay_anim" mode="out-in">
      <div id="termsOpen" class="overlay" v-if="termsOpen">
        <a class="close" @click="termsOpen = !termsOpen"></a>
        <div class="overlay-content">
          <h2 class="overlay_title">
            Terms of Use
            <span>利用規約</span>
          </h2>
          <div class="overlayWrapper">
            <h3>免責事項</h3>
            <p>
              当サイトは全て自己責任で利用するものとし、生じた不利益について管理者は一切の責任を負わないものとします。アップロードしたファイルに関する責任は、全て利用者が持ち、管理者は一切の責任を負わないものとします。予告なしにサービスを停止、変更する場合がある事をご了承下さい。また、管理者は一切の責任を負わないものとします。
            </p>
            <h3>禁止行為</h3>
            <p>
              著作権や肖像権等、第三者の権利を侵害するファイルをアップロードする行為。他人の身体、生命、自由、名誉、財産等に対して害悪を加える情報をアップロードする行為。日本の法律に違反する行為。大容量のファイルを不特定多数に配布する等、インフラに極端な負荷をかける行為。コンピュータウイルスの配布等、利用者に何らかの悪影響を生じさせる行為。ダウンロード支援ツール等でサーバーに著しく負荷をかける行為。その他、管理者が不適切と判断する行為。不適切な利用が発覚した場合は、予告なくファイルの削除やアクセス制限等の対応をとる可能性があります。
            </p>
            <h3>利用規約への同意</h3>
            <p>
              利用にあたっては、その使用をもって、この利用規約及び免責事項に同意したものとみなします。
            </p>
            <h3>利用規約の改定について</h3>
            <p>
              当サイトは事前の通告無しに全ての条項を改訂できるものとします。
            </p>
          </div>
        </div>
      </div>
    </transition>

    <transition name="overlay_anim" mode="out-in">
      <div id="policyOpen" class="overlay" v-if="policyOpen">
        <a class="close" @click="policyOpen = !policyOpen"></a>
        <div class="overlay-content">
          <h2 class="overlay_title">
            Security Policy
            <span>利用規約</span>
          </h2>
          <div class="overlayWrapper">
            <h3>免責事項</h3>
            <p>
              当サイトは全て自己責任で利用するものとし、生じた不利益について管理者は一切の責任を負わないものとします。アップロードしたファイルに関する責任は、全て利用者が持ち、管理者は一切の責任を負わないものとします。予告なしにサービスを停止、変更する場合がある事をご了承下さい。また、管理者は一切の責任を負わないものとします。
            </p>
            <h3>禁止行為</h3>
            <p>
              著作権や肖像権等、第三者の権利を侵害するファイルをアップロードする行為。他人の身体、生命、自由、名誉、財産等に対して害悪を加える情報をアップロードする行為。日本の法律に違反する行為。大容量のファイルを不特定多数に配布する等、インフラに極端な負荷をかける行為。コンピュータウイルスの配布等、利用者に何らかの悪影響を生じさせる行為。ダウンロード支援ツール等でサーバーに著しく負荷をかける行為。その他、管理者が不適切と判断する行為。不適切な利用が発覚した場合は、予告なくファイルの削除やアクセス制限等の対応をとる可能性があります。
            </p>
            <h3>利用規約への同意</h3>
            <p>
              利用にあたっては、その使用をもって、この利用規約及び免責事項に同意したものとみなします。
            </p>
            <h3>利用規約の改定について</h3>
            <p>
              当サイトは事前の通告無しに全ての条項を改訂できるものとします。
            </p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      termsOpen: false,
      policyOpen: false
    };
  }
};
</script>

<style scoped lang="scss"></style>
